<mat-toolbar color="primary" class="central-menu">
  <mat-toolbar-row>
    <button mat-icon-button (click)="onToggleSidenav()">
      <span class="material-icons primary-gray">
        menu
      </span>
    </button>
    <div class="header-brand-slot">      <div [routerLink]="'/dashboard/gender'" class="header-logos">
        <img class="header-logo-cogent" src="assets/img/cogent-logo.png" alt="Cogent">
      </div>
    </div>

    <span class="spacer"></span>

    <div class="global-theme-wrap" (click)="$event.stopPropagation()">
      <button type="button" class="global-theme-trigger" (click)="showThemePicker = !showThemePicker" title="Colour Theme">
        <span class="theme-dot-sm" [style.background]="activeTheme.color"></span>
        <span class="theme-trigger-label">Theme</span>
        <span class="material-icons">expand_more</span>
      </button>
      <div *ngIf="showThemePicker" class="global-theme-picker">
        <div class="theme-picker-label">Colour Theme</div>
        <button *ngFor="let t of themes"
                type="button"
                class="theme-option"
                [class.active]="t.id === theme"
                (click)="applyTheme(t.id)">
          <span class="theme-dot" [style.background]="t.color"></span>
          <span class="theme-info">
            <span class="theme-name">{{ t.label }}</span>
            <span class="theme-sub">{{ t.sub }}</span>
          </span>
          <span *ngIf="t.id === theme" class="theme-check">✓</span>
        </button>
      </div>
    </div>

    <button mat-icon-button [matMenuTriggerFor]="notificationMenu" class="notification-trigger">
  <mat-icon
    [matBadge]="badgeLabel"
    [matBadgeHidden]="getNotificationCount() === 0"
    matBadgeColor="warn"
    matBadgeSize="small">
    notifications
  </mat-icon>
</button>

    <mat-menu #notificationMenu="matMenu" class="notification-menu">
      <div class="notification-header" (click)="$event.stopPropagation()">
        <h3>Notifications</h3>
      </div>
      <mat-divider></mat-divider>

      <div class="notification-list" (click)="$event.stopPropagation()">
        <div *ngFor="let notification of notifications" class="notification-item" [class.unread]="!notification.read"
          (click)="viewComplaint(notification)">

          <div class="notification-content">
            <div class="notification-title">{{ notification.title }}</div>
            <div class="notification-message">{{ notification.message }}</div>
            <div class="notification-footer-info">
              <div class="notification-time">{{ notification.time }}</div>
              <div *ngIf="!notification.read" class="mark-as-read-btn" (click)="markAsRead(notification, $event)">
                Mark as read
              </div>
            </div>
          </div>

          <!-- <div *ngIf="!notification.read" class="unread-indicator"></div> -->
        </div>

        <div *ngIf="notifications.length === 0" class="no-notifications">
          <mat-icon>notifications_none</mat-icon>
          <p>No notifications</p>
        </div>
      </div>

    </mat-menu>


    <span class="logo me-3 pointer" [matMenuTriggerFor]="settingsMenu" style="margin-left: 20px;">
      <svg width="20" height="20" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M16 0C7.1632 0 0 7.1632 0 16C0 24.8368 7.1632 32 16 32C24.8368 32 32 24.8368 32 16C32 7.1632 24.8368 0 16 0ZM10.4 12C10.4 11.2646 10.5448 10.5364 10.8263 9.85697C11.1077 9.17755 11.5202 8.56021 12.0402 8.0402C12.5602 7.52019 13.1776 7.1077 13.857 6.82627C14.5364 6.54485 15.2646 6.4 16 6.4C16.7354 6.4 17.4636 6.54485 18.143 6.82627C18.8225 7.1077 19.4398 7.52019 19.9598 8.0402C20.4798 8.56021 20.8923 9.17755 21.1737 9.85697C21.4552 10.5364 21.6 11.2646 21.6 12C21.6 13.4852 21.01 14.9096 19.9598 15.9598C18.9096 17.01 17.4852 17.6 16 17.6C14.5148 17.6 13.0904 17.01 12.0402 15.9598C10.99 14.9096 10.4 13.4852 10.4 12ZM26.0128 23.9744C24.8151 25.481 23.2925 26.6975 21.5587 27.5331C19.8249 28.3687 17.9247 28.8018 16 28.8C14.0753 28.8018 12.1751 28.3687 10.4413 27.5331C8.70752 26.6975 7.1849 25.481 5.9872 23.9744C8.5808 22.1136 12.12 20.8 16 20.8C19.88 20.8 23.4192 22.1136 26.0128 23.9744Z"
          fill="#04A251" />
      </svg>
      <span class="screen-details ml-1 hide-mobile">{{userName}}</span>
    </span>
    <mat-menu #settingsMenu="matMenu">
      <button mat-menu-item [routerLink]="'/profile'">
        <img src="assets/img/profile_icon.svg" alt="Profile Icon" width="16" height="16" style="margin-right: 8px;">

        {{'PROFILE' | translate}}</button>
      <button mat-menu-item (click)="logout()">
        <img src="assets/img/logout.svg" alt="Logout Icon" width="16" height="16" style="margin-right: 8px;">
        {{'LOGOUT'| translate}}
      </button>
    </mat-menu>
  </mat-toolbar-row>
</mat-toolbar>
